// Blog Images Configuration
// Update images here easily without touching the blog posts code

export const blogImageConfig = {
  // Service-specific hero images
  seo: 'https://images.unsplash.com/photo-1460925895917-afdab827c52f?auto=format&fit=crop&w=1600&q=80',
  ppc: 'https://images.unsplash.com/photo-1520607162513-77705c0f0d4a?auto=format&fit=crop&w=1600&q=80',
  socialMedia: 'https://images.unsplash.com/photo-1611162617474-5b21e879e113?auto=format&fit=crop&w=1600&q=80',
  webDesign: 'https://images.unsplash.com/photo-1498050108023-c5249f4df085?auto=format&fit=crop&w=1600&q=80',
  contentMarketing: 'https://images.unsplash.com/photo-1526481280695-3c469c2f58c0?auto=format&fit=crop&w=1600&q=80',
  consulting: 'https://images.unsplash.com/photo-1454165205744-3b78555e5572?auto=format&fit=crop&w=1600&q=80',
  emailMarketing: 'https://images.unsplash.com/photo-1563986768609-322da13575f3?auto=format&fit=crop&w=1600&q=80',
  aiServices: 'https://images.unsplash.com/photo-1677442136019-21780ecad995?auto=format&fit=crop&w=1600&q=80',
  
  // Supporting images for sections
  analytics: 'https://images.unsplash.com/photo-1551288049-bebda4e38f71?auto=format&fit=crop&w=1600&q=80',
  strategy: 'https://images.unsplash.com/photo-1552664730-d307ca884978?auto=format&fit=crop&w=1600&q=80',
  team: 'https://images.unsplash.com/photo-1522071820081-009f0129c71c?auto=format&fit=crop&w=1600&q=80',
  growth: 'https://images.unsplash.com/photo-1460925895917-afdab827c52f?auto=format&fit=crop&w=1600&q=80',
  technology: 'https://images.unsplash.com/photo-1518770660439-4636190af475?auto=format&fit=crop&w=1600&q=80',
  results: 'https://images.unsplash.com/photo-1551288049-bebda4e38f71?auto=format&fit=crop&w=1600&q=80',
};

// Gallery sets for each service category
export const serviceGalleries = {
  seo: [
    blogImageConfig.analytics,
    blogImageConfig.strategy,
    blogImageConfig.growth,
  ],
  ppc: [
    blogImageConfig.analytics,
    blogImageConfig.growth,
    blogImageConfig.results,
  ],
  socialMedia: [
    blogImageConfig.team,
    blogImageConfig.analytics,
    blogImageConfig.growth,
  ],
  webDesign: [
    blogImageConfig.technology,
    blogImageConfig.strategy,
    blogImageConfig.results,
  ],
  contentMarketing: [
    blogImageConfig.strategy,
    blogImageConfig.analytics,
    blogImageConfig.team,
  ],
  consulting: [
    blogImageConfig.strategy,
    blogImageConfig.team,
    blogImageConfig.results,
  ],
  emailMarketing: [
    blogImageConfig.analytics,
    blogImageConfig.strategy,
    blogImageConfig.results,
  ],
  aiServices: [
    blogImageConfig.technology,
    blogImageConfig.analytics,
    blogImageConfig.growth,
  ],
};

// Instructions: 
// To update any image, simply replace the URL in the blogImageConfig object above
// All blog posts will automatically use the updated images
